<section class="section-page" [class.visible]="isVisible">
  <div class="section-page__container">
    <a routerLink="/" class="section-page__back">← Volver al portfolio</a>
    <div class="section-page__header">
      <h1 class="section-page__title">Proyectos</h1>
      <div class="section-page__accent-line"></div>
    </div>
    <p class="section-page__intro-text">
      Una selección de proyectos que resumen cómo trabajo: contexto real, atención al detalle,
      foco en producto y soluciones pensadas para durar.
    </p>
    <div class="projects-grid">
      <div class="project-card" *ngFor="let project of projects; let i = index">
        <div class="project-card__header">
          <svg class="project-card__icon" viewBox="0 0 40 40" fill="none" stroke="currentColor"
               stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="4" y="6" width="32" height="28" rx="3"/>
            <line x1="4" y1="14" x2="36" y2="14"/>
            <circle cx="10" cy="10" r="1.5" fill="currentColor" stroke="none"/>
            <circle cx="16" cy="10" r="1.5" fill="currentColor" stroke="none"/>
            <polyline points="14 22 10 26 14 30"/>
            <polyline points="24 22 28 26 24 30"/>
            <line x1="20" y1="20" x2="18" y2="32"/>
          </svg>
          <span class="project-card__number">0{{ i + 1 }}</span>
        </div>
        <h3 class="project-card__title">{{ project.title }}</h3>
        <p class="project-card__desc">{{ project.description }}</p>
        <div class="project-card__tags">
          <span class="project-card__tag" *ngFor="let tag of project.tags">{{ tag }}</span>
        </div>
        <div class="project-card__links" *ngIf="project.githubUrl || project.liveUrl">
          <a *ngIf="project.githubUrl" [href]="project.githubUrl" target="_blank"
             rel="noopener noreferrer" class="project-card__link" (click)="$event.stopPropagation()">
            GitHub
          </a>
          <a *ngIf="project.liveUrl" [href]="project.liveUrl" target="_blank"
             rel="noopener noreferrer" class="project-card__link project-card__link--live" (click)="$event.stopPropagation()">
            Ver web
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
